
  export const UI_GIT_BRANCH='release/2.1.29';
  export const UI_GIT_VERSION='d8b63e5b';
  export const UI_GIT_TAG='2.1.29';
